import { createSelector } from 'reselect';
import UserStore from '../stores/UserStore';

const getList = (statuses) => {
    let list = [];

    Object.keys(statuses).map((key) => {
        list.push({
            value: key,
            title: statuses[key]
        });
    });

    return list;
};

export const getStatuses = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().statuses;

        return getList(staticNames);
    }
);

export const getConversionStatuses = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().conversionStatuses;

        return getList(staticNames);
    }
);

export const getGoalEntriesStatuses = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().goalEntriesStatuses;

        return getList(staticNames);
    }
);